import script from "./PageHeadBack.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeadBack.vue?vue&type=script&setup=true&lang=js"

import "./PageHeadBack.vue?vue&type=style&index=0&id=3d8c08db&lang=scss"

const __exports__ = script;

export default __exports__